export default __webpack_public_path__ + "static/media/partner.2e7e3161.svg";